// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"784bac6e","538":"42f16ad5","802":"68435c60"}[chunkId] + ".chunk.js";
};